import { render, staticRenderFns } from "./PasswordRecovery.html?vue&type=template&id=ad4b1f6a&scoped=true&external"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecovery.scss?vue&type=style&index=0&id=ad4b1f6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4b1f6a",
  null
  
)

export default component.exports